
import {useStateContext} from "../contexts/ContextProvider";
import {Fragment} from "./Fragment";
import {useState} from "react";

export const Paragraph = ({content, index, bookMark, setBookMark, currentChapter}) => {

    const {main} = useStateContext();

    return (
        <p className={main === "eng" ? "pb-2" : "indent-8 text-justify"}>
            {content.map((fragment, i) => {
                return <Fragment
                    key={`${index}-${i}`}
                    content={fragment}
                    index={`${index}-${i}`}
                    bookMark={bookMark}
                    setBookMark={setBookMark}
                    currentChapter={currentChapter}
                />
            })}
        </p>
    );
};
